<template>
  <div class="userManage">
    <box title="用户管理">
      <div class="userManage__context">
        <f-filter
          ref="filter"
          :filter-form="formFilter"
          @sendForm="getForm"
          @on-reset="onRefresh"
          @sendTree="getOrgTree"
        ></f-filter>
        <div class="tool">
          <el-button type="primary" @click="addUser" v-show="menusList.indexOf('USER_MANAGE_ADD')!='-1'">新增用户</el-button>
        </div>
        <div class="tableList">
          <el-table :data="tableList" class="table" v-loading="loading">
            <el-table-column
              prop="loginName"
              align="center"
              label="用户名"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="deptName"
              align="center"
              label="所属组织"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="roleName"
              align="center"
              label="角色"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="userName"
              align="center"
              label="使用人"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="userLabel"
              align="center"
              label="标签"
            ></el-table-column>
            <el-table-column
              prop="phone"
              align="center"
              label="联系方式"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="updateDate"
              align="center"
              label="修改时间"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="state"
              align="center"
              label="帐号状态"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <span v-if="scope.row.state == 2"> 停用 </span>
                <span v-if="scope.row.state == 1"> 启用 </span>
              </template>
            </el-table-column>
            <el-table-column
              prop="userDesc"
              align="center"
              label="备注"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column align="center" label="操作" width="180px">
              <template slot-scope="scope">
                <div class="btnGroup">
                  <span
                    class="table__list__btn"
                    @click="editPassword(scope.row)"
                    v-show="menusList.indexOf('USER_MANAGE_UPDATE_PWD')!='-1'"
                  >
                    修改密码
                  </span>
                  <span class="table__list__btn" @click="editDialog(scope.row)"  v-show="menusList.indexOf('USER_MANAGE_MODIFY')!='-1'">
                    编辑
                  </span>
                  <span class="table__list__btn" @click="onDelete(scope.row)"  v-show="menusList.indexOf('USER_MANAGE_DELETE')!='-1'">
                    删除
                  </span>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="page">
          <el-pagination
            @current-change="pageChange"
            background
            :current-page="page"
            :page-size="sizePage"
            layout="total,prev, pager, next, jumper"
            :total="totalSum"
          >
          </el-pagination>
        </div>
      </div>
    </box>

    <el-dialog
      :title="`${this.action == 'add' ? '新增' : '编辑'}用户`"
      width="40%"
      :visible.sync="dialog"
      class="onDialog"
      :close-on-click-modal="false"
      :top="'20vh'"
    >
      <el-form
        label-width="100px"
        class="onDialog__form"
        :model="form"
        ref="form"
        :rules="rules"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item label="用户名" prop="loginName">
              <el-input
                v-model="form.loginName"
                size="large"
              ></el-input> </el-form-item
          ></el-col>
          <el-col :span="12">
            <el-form-item label="密码" prop="pwd" v-if="action == 'add'">
              <el-input
                show-password
                v-model="form.pwd"
                size="large"
              ></el-input> </el-form-item
          ></el-col>
          <el-col :span="12">
            <el-form-item label="所属组织" prop="deptId">
              <el-cascader
                style="width: 100%"
                size="large"
                v-model="form.deptId"
                :options="deptList"
                :props="{
                  expandTrigger: 'hover',
                  value: 'deptId',
                  label: 'deptName',
                  checkStrictly: true,
                }"
              ></el-cascader>
            </el-form-item
          ></el-col>
          <el-col :span="12">
            <el-form-item label="角色" prop="roleId">
              <el-select v-model="form.roleId" size="large" style="width: 100%">
                <el-option
                  v-for="item in roleList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select> </el-form-item
          ></el-col>
          <el-col :span="12">
            <el-form-item label="使用人" prop="userName">
              <el-input
                v-model="form.userName"
                size="large"
              ></el-input> </el-form-item
          ></el-col>
          <el-col :span="12">
            <el-form-item label="手机号" prop="phone">
              <el-input
                v-model="form.phone"
                size="large"
              ></el-input> </el-form-item
          ></el-col>

          <el-col :span="12">
            <el-form-item label="用户标签">
              <el-select
                v-model="form.labelId"
                size="large"
                style="width: 100%"
              >
                <el-option
                  v-for="item in labelList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option> </el-select></el-form-item
          ></el-col>

          <el-col :span="12">
            <el-form-item label="备注">
              <el-input
                v-model="form.userDesc"
                type="textarea"
                size="large"
              ></el-input> </el-form-item
          ></el-col>
          <el-col :span="12">
            <el-form-item label="账号状态">
              <el-switch
                v-model="form.state"
                active-color="#13ce66"
                inactive-color="#ff4949"
                :active-value="1"
                :inactive-value="2"
              >
              </el-switch> </el-form-item
          ></el-col>
        </el-row>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="confirm">确 定</el-button>
        <el-button @click="dialog = false">取 消</el-button>
      </span>
    </el-dialog>

    <edit-pwd ref="pwd" :pwdDialog.sync="pwdDialog"></edit-pwd>
  </div>
</template>

<script>
import Axios from "@/utils/Axios";
import box from "../../component/box";
import fFilter from "../../component/filter";
import editPwd from "./components/editPassword";
import Vue from "vue";
export default {
  name: "userMangerPage",
  components: { box, fFilter, editPwd },
  data() {
    return {
      itemId: "",
      userId: "",
      action: "",
      userName: "",
      page: 1,
      sizePage: 10,
      totalSum: 0,
      pwdDialog: false,
      dialog: false,
      loading: false,
      formFilter: [
        {
          name: "用户名",
          field: "userName",
          type: "input",
          span: 5,
        },
        {
          name: "所属组织",
          type: "tree",
          checkStrictly: true,
          span: 6,
          field: "deptId",
        },
      ],
      tableList: [],
      form: {
        state: 1,
        labelId: 3,
      },
      deptList: [],
      menusList: [],
      roleList: [],
      labelList: [],
      rules: {
        loginName: [
          { required: true, message: "请输入用户名", trigger: "blur" },
        ],
        userName: [
          { required: true, message: "请输入使用人", trigger: "blur" },
        ],
        pwd: [
          {
            min: 6,
            max: 16,
            required: true,
            trigger: "blur",
            message: "密码长度必须在6~16位！",
          },
        ],
        deptId: [{ required: true, message: "请选择单位", trigger: "blur" }],
        roleId: [{ required: true, message: "请选择角色", trigger: "blur" }],
        phone: [
          { required: false, trigger: "blur" },
          {
            pattern: /^((0\d{2,3}-\d{7,8})|(1[3584]\d{9}))$/,
            message: "请输入合法手机号/电话号",
            trigger: "blur",
          },
        ],
      },
      pwd: "",
    };
  },
  methods: {
    editPassword(row) {
      this.$refs.pwd.getId(row.userId);
      this.pwdDialog = true;
    },
    getOrgTree(tree) {
      this.deptList = tree;
    },
    editDialog(row) {
      this.action = "edit";
      this.form = row;
      this.dialog = true;
    },
    addUser() {
      this.form = {
        state: 1,
      };
      this.action = "add";
      this.dialog = true;
    },

    confirm() {
      this.$refs.form.validate((va) => {
        if (va) {
          if (this.action == "add") {
            const params = {
              url: "/user/add",
              method: "post",
              data: {
                deptId: Array.isArray(this.form.deptId)
                  ? this.form.deptId[this.form.deptId.length - 1]
                  : this.form.deptId,
                loginName: this.form.loginName,
                phone: this.form.phone || "",
                pwd: this.form.pwd,
                state: this.form.state,
                roleId: this.form.roleId || "",
                userLabel: this.form.labelId || "",
                userName: this.form.userName || "",
                userDesc: this.form.userDesc || "",
              },
            };
            Axios.ajax(params).then((res) => {
              this.dialog = false;
              this.$refs.filter.onSearch(true);
              if (res.resultCode == 0) {
                this.$message.success("新增成功！");
              } else {
                this.$message.warning(res.resultMessage);
              }
            });
          } else {
            const params = {
              url: "/user/modify",
              method: "post",
              data: {
                deptId: Array.isArray(this.form.deptId)
                  ? this.form.deptId[this.form.deptId.length - 1]
                  : this.form.deptId,
                loginName: this.form.loginName,
                phone: this.form.phone || "",
                state: this.form.state,
                roleId: this.form.roleId || "",
                userLabel: this.form.labelId || "",
                userName: this.form.userName || "",
                userDesc: this.form.userDesc || "",
                userId: this.form.userId,
              },
            };
            Axios.ajax(params).then((res) => {
              this.$refs.filter.onSearch(true);
              if (res.resultCode == 0) {
                this.dialog = false;
                this.$message.success("修改成功！");
              } else {
                this.$message.warning(res.resultMessage);
              }
            });
          }
        }
      });
    },
    pageChange(val) {
      this.page = val;
      this.$refs.filter.onSearch();
    },
    onRefresh(form) {
      this.queryTableList(form);
    },
    onDelete(row) {
      let that=this
      this.$confirm("确认删除？", '提示', {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: 'warning'
      }).then(() => {
        Axios.ajax({
          url: "/user/delete",
          method: "post",
          data: {
            userId: row.userId,
          },
        }).then((res) => {
          that.$refs.filter.onSearch(true);
          if (res.resultCode == 0) {
            that.$message.success("删除成功！");
          } else {
            that.$message.warning( res.resultMessage);
          }
        });
      })

    },
    getForm(form, key) {
      if (key) {
        this.page = 1;
        this.queryTableList(form);
      } else {
        this.queryTableList(form);
      }
    },
    queryTableList(form) {
      this.loading = true;
      Axios.ajax({
        url: "/user/getSubUsersPage",
        method: "get",
        params: {
          userName: form.userName,
          deptId: Array.isArray(form.deptId)
            ? form.deptId[form.deptId.length - 1]
            : form.deptId,
          pageNum: this.page,
          showNum: this.sizePage,
        },
      }).then((res) => {
        this.loading = false;
        this.tableList = res.data.dataList;
        this.totalSum = res.data.totalNum;
      });
    },
    queryRoleList() {
      Axios.ajax({
        url: "/role/list",
        method: "get",
        params: {
          userId: this.userId,
        },
      }).then((res) => {
        if (res.resultCode == 0) {
          this.roleList = res.data.map((item) => {
            return {
              label: item.roleName,
              value: item.roleId,
            };
          });
        }
      });
    },
    queryLabelList() {
      const param = {};
      param.method = "post";
      param.url = "/label/findLabels";
      param.datas = {

      };
      Axios.ajax(param).then((res) => {
        if (res.data) {
          this.labelList = res.data.map((item) => {
            return {
              value: item.labelId,
              label: item.labelName,
            };
          });
          this.labelList.unshift({
            label: "全部",
            value: null,
          });
        }
      });
    },
  },
  created() {
    this.userId = localStorage.getItem("userId");
  },
  mounted() {
    this.menusList=Vue.prototype.menusList
    this.queryLabelList();
    this.queryRoleList();
  },
};
</script>

<style lang="less" scoped>
.userManage {
  &__context {
    height: 100%;
    padding: 36px;
    overflow: auto;
    position: relative;

    .tool {
      margin: 20px 0;
      width: 100%;
      text-align: right;

    }
    .tableList {
      margin-top: 20px;
      height: 560px;
      .table {
        height: 95%;
        overflow: auto;
      }
    }
    .page {
      position: absolute;
      bottom:-20px;
      right: 0;
      margin-bottom: 36px;
    }
  }
}
.btnGroup {
  cursor: pointer;
  color: #2a62ff;
  font-weight: normal;
  .table__list__btn {
    margin: 0 5px;
  }
}
.onDialog {
  &__form {
    padding: 0 10px;
  }
}
</style>

<style>
#app .el-pagination .el-pager li.active {
  color: #fff;
}
</style>
